import React from "react";
import PropTypes from "prop-types";
import { Select as AntSelect } from "antd";
import { v4 as uuidv4 } from "uuid";
import { UiSelect } from "./Select.style";
/**
 * 下拉選單
 */

const Select = ({
  options = [],
  className,
  label,
  onChange,
  onClear,
  disabled,
  message,
  value,
  defaultValue,
  placeholder,
  getPopupContainer = () => document.getElementById("root"),
  dropdownStyle,
  row = false,
  mode,
  showArrow,
  variant,
  allowClear = true
}) => {
  return /*#__PURE__*/React.createElement(UiSelect, {
    row: row,
    variant: variant,
    className: className
  }, label && /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement(AntSelect, {
    mode: mode,
    showArrow: showArrow,
    onChange: onChange,
    onClear: onClear,
    value: value,
    defaultValue: defaultValue,
    allowClear: allowClear,
    disabled: disabled,
    getPopupContainer: getPopupContainer,
    dropdownStyle: dropdownStyle,
    placeholder: placeholder
  }, options.map(option => {
    return /*#__PURE__*/React.createElement(AntSelect.Option, {
      key: uuidv4(),
      value: option.value,
      label: option.name
    }, option.name);
  })), message && /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};

export default Select;
Select.propTypes = {
  options: PropTypes.array,
  className: PropTypes.string,
  label: PropTypes.string,
  message: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  row: PropTypes.bool,
  placeholder: PropTypes.string,
  mode: PropTypes.string,
  disabled: PropTypes.bool,
  getPopupContainer: PropTypes.func,
  dropdownStyle: PropTypes.object,
  showArrow: PropTypes.bool,
  variant: PropTypes.string,
  allowClear: PropTypes.bool
};